import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getMainCarrier } from '../carrier.js';
import { withScope, getCurrentScope, getIsolationScope, getClient } from '../currentScopes.js';
import { getAsyncContextStrategy } from '../asyncContext/index.js';
import { DEBUG_BUILD } from '../debug-build.js';
import { SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE } from '../semanticAttributes.js';
import { logger } from '../utils-hoist/logger.js';
import { generateTraceId } from '../utils-hoist/propagationContext.js';
import { propagationContextFromHeaders } from '../utils-hoist/tracing.js';
import { handleCallbackErrors } from '../utils/handleCallbackErrors.js';
import { hasTracingEnabled } from '../utils/hasTracingEnabled.js';
import { _setSpanForScope, _getSpanForScope } from '../utils/spanOnScope.js';
import { spanToJSON, addChildSpanToSpan, spanIsSampled, spanTimeInputToSeconds, getRootSpan } from '../utils/spanUtils.js';
import { getDynamicSamplingContextFromSpan, freezeDscOnSpan } from './dynamicSamplingContext.js';
import { logSpanStart } from './logSpans.js';
import { sampleSpan } from './sampling.js';
import { SentryNonRecordingSpan } from './sentryNonRecordingSpan.js';
import { SentrySpan } from './sentrySpan.js';
import { SPAN_STATUS_ERROR } from './spanstatus.js';
import { setCapturedScopesOnSpan } from './utils.js';
var SUPPRESS_TRACING_KEY = '__SENTRY_SUPPRESS_TRACING__';

/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */
function startSpan(options, callback) {
  var acs = getAcs();
  if (acs.startSpan) {
    return acs.startSpan(options, callback);
  }
  var spanArguments = parseSentrySpanArguments(options);
  var forceTransaction = options.forceTransaction,
    customParentSpan = options.parentSpan;
  return withScope(options.scope, function () {
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    var wrapper = getActiveSpanWrapper(customParentSpan);
    return wrapper(function () {
      var scope = getCurrentScope();
      var parentSpan = getParentSpan(scope);
      var shouldSkipSpan = options.onlyIfParent && !parentSpan;
      var activeSpan = shouldSkipSpan ? new SentryNonRecordingSpan() : createChildOrRootSpan({
        parentSpan: parentSpan,
        spanArguments: spanArguments,
        forceTransaction: forceTransaction,
        scope: scope
      });
      _setSpanForScope(scope, activeSpan);
      return handleCallbackErrors(function () {
        return callback(activeSpan);
      }, function () {
        // Only update the span status if it hasn't been changed yet, and the span is not yet finished
        var _spanToJSON = spanToJSON(activeSpan),
          status = _spanToJSON.status;
        if (activeSpan.isRecording() && (!status || status === 'ok')) {
          activeSpan.setStatus({
            code: SPAN_STATUS_ERROR,
            message: 'internal_error'
          });
        }
      }, function () {
        return activeSpan.end();
      });
    });
  });
}

/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */
function startSpanManual(options, callback) {
  var acs = getAcs();
  if (acs.startSpanManual) {
    return acs.startSpanManual(options, callback);
  }
  var spanArguments = parseSentrySpanArguments(options);
  var forceTransaction = options.forceTransaction,
    customParentSpan = options.parentSpan;
  return withScope(options.scope, function () {
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    var wrapper = getActiveSpanWrapper(customParentSpan);
    return wrapper(function () {
      var scope = getCurrentScope();
      var parentSpan = getParentSpan(scope);
      var shouldSkipSpan = options.onlyIfParent && !parentSpan;
      var activeSpan = shouldSkipSpan ? new SentryNonRecordingSpan() : createChildOrRootSpan({
        parentSpan: parentSpan,
        spanArguments: spanArguments,
        forceTransaction: forceTransaction,
        scope: scope
      });
      _setSpanForScope(scope, activeSpan);
      function finishAndSetSpan() {
        activeSpan.end();
      }
      return handleCallbackErrors(function () {
        return callback(activeSpan, finishAndSetSpan);
      }, function () {
        // Only update the span status if it hasn't been changed yet, and the span is not yet finished
        var _spanToJSON2 = spanToJSON(activeSpan),
          status = _spanToJSON2.status;
        if (activeSpan.isRecording() && (!status || status === 'ok')) {
          activeSpan.setStatus({
            code: SPAN_STATUS_ERROR,
            message: 'internal_error'
          });
        }
      });
    });
  });
}

/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */
function startInactiveSpan(options) {
  var acs = getAcs();
  if (acs.startInactiveSpan) {
    return acs.startInactiveSpan(options);
  }
  var spanArguments = parseSentrySpanArguments(options);
  var forceTransaction = options.forceTransaction,
    customParentSpan = options.parentSpan;

  // If `options.scope` is defined, we use this as as a wrapper,
  // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
  var wrapper = options.scope ? function (callback) {
    return withScope(options.scope, callback);
  } : customParentSpan !== undefined ? function (callback) {
    return withActiveSpan(customParentSpan, callback);
  } : function (callback) {
    return callback();
  };
  return wrapper(function () {
    var scope = getCurrentScope();
    var parentSpan = getParentSpan(scope);
    var shouldSkipSpan = options.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) {
      return new SentryNonRecordingSpan();
    }
    return createChildOrRootSpan({
      parentSpan: parentSpan,
      spanArguments: spanArguments,
      forceTransaction: forceTransaction,
      scope: scope
    });
  });
}

/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */
var continueTrace = function continueTrace(options, callback) {
  var carrier = getMainCarrier();
  var acs = getAsyncContextStrategy(carrier);
  if (acs.continueTrace) {
    return acs.continueTrace(options, callback);
  }
  var sentryTrace = options.sentryTrace,
    baggage = options.baggage;
  return withScope(function (scope) {
    var propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
    scope.setPropagationContext(propagationContext);
    return callback();
  });
};

/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */
function withActiveSpan(span, callback) {
  var acs = getAcs();
  if (acs.withActiveSpan) {
    return acs.withActiveSpan(span, callback);
  }
  return withScope(function (scope) {
    _setSpanForScope(scope, span || undefined);
    return callback(scope);
  });
}

/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */
function suppressTracing(callback) {
  var acs = getAcs();
  if (acs.suppressTracing) {
    return acs.suppressTracing(callback);
  }
  return withScope(function (scope) {
    scope.setSDKProcessingMetadata(_defineProperty({}, SUPPRESS_TRACING_KEY, true));
    return callback();
  });
}

/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */
function startNewTrace(callback) {
  return withScope(function (scope) {
    scope.setPropagationContext({
      traceId: generateTraceId()
    });
    DEBUG_BUILD && logger.info("Starting a new trace with id ".concat(scope.getPropagationContext().traceId));
    return withActiveSpan(null, callback);
  });
}
function createChildOrRootSpan(_ref) {
  var parentSpan = _ref.parentSpan,
    spanArguments = _ref.spanArguments,
    forceTransaction = _ref.forceTransaction,
    scope = _ref.scope;
  if (!hasTracingEnabled()) {
    return new SentryNonRecordingSpan();
  }
  var isolationScope = getIsolationScope();
  var span;
  if (parentSpan && !forceTransaction) {
    span = _startChildSpan(parentSpan, scope, spanArguments);
    addChildSpanToSpan(parentSpan, span);
  } else if (parentSpan) {
    // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
    var dsc = getDynamicSamplingContextFromSpan(parentSpan);
    var _parentSpan$spanConte = parentSpan.spanContext(),
      traceId = _parentSpan$spanConte.traceId,
      parentSpanId = _parentSpan$spanConte.spanId;
    var parentSampled = spanIsSampled(parentSpan);
    span = _startRootSpan(_objectSpread({
      traceId: traceId,
      parentSpanId: parentSpanId
    }, spanArguments), scope, parentSampled);
    freezeDscOnSpan(span, dsc);
  } else {
    var _isolationScope$getPr = _objectSpread(_objectSpread({}, isolationScope.getPropagationContext()), scope.getPropagationContext()),
      _traceId = _isolationScope$getPr.traceId,
      _dsc = _isolationScope$getPr.dsc,
      _parentSpanId = _isolationScope$getPr.parentSpanId,
      _parentSampled = _isolationScope$getPr.sampled;
    span = _startRootSpan(_objectSpread({
      traceId: _traceId,
      parentSpanId: _parentSpanId
    }, spanArguments), scope, _parentSampled);
    if (_dsc) {
      freezeDscOnSpan(span, _dsc);
    }
  }
  logSpanStart(span);
  setCapturedScopesOnSpan(span, scope, isolationScope);
  return span;
}

/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */
function parseSentrySpanArguments(options) {
  var exp = options.experimental || {};
  var initialCtx = _objectSpread({
    isStandalone: exp.standalone
  }, options);
  if (options.startTime) {
    var ctx = _objectSpread({}, initialCtx);
    ctx.startTimestamp = spanTimeInputToSeconds(options.startTime);
    delete ctx.startTime;
    return ctx;
  }
  return initialCtx;
}
function getAcs() {
  var carrier = getMainCarrier();
  return getAsyncContextStrategy(carrier);
}
function _startRootSpan(spanArguments, scope, parentSampled) {
  var client = getClient();
  var options = client && client.getOptions() || {};
  var _spanArguments$name = spanArguments.name,
    name = _spanArguments$name === void 0 ? '' : _spanArguments$name,
    attributes = spanArguments.attributes;
  var _ref2 = scope.getScopeData().sdkProcessingMetadata[SUPPRESS_TRACING_KEY] ? [false] : sampleSpan(options, {
      name: name,
      parentSampled: parentSampled,
      attributes: attributes,
      transactionContext: {
        name: name,
        parentSampled: parentSampled
      }
    }),
    _ref3 = _slicedToArray(_ref2, 2),
    sampled = _ref3[0],
    sampleRate = _ref3[1];
  var rootSpan = new SentrySpan(_objectSpread(_objectSpread({}, spanArguments), {}, {
    attributes: _objectSpread(_defineProperty({}, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, 'custom'), spanArguments.attributes),
    sampled: sampled
  }));
  if (sampleRate !== undefined) {
    rootSpan.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE, sampleRate);
  }
  if (client) {
    client.emit('spanStart', rootSpan);
  }
  return rootSpan;
}

/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */
function _startChildSpan(parentSpan, scope, spanArguments) {
  var _parentSpan$spanConte2 = parentSpan.spanContext(),
    spanId = _parentSpan$spanConte2.spanId,
    traceId = _parentSpan$spanConte2.traceId;
  var sampled = scope.getScopeData().sdkProcessingMetadata[SUPPRESS_TRACING_KEY] ? false : spanIsSampled(parentSpan);
  var childSpan = sampled ? new SentrySpan(_objectSpread(_objectSpread({}, spanArguments), {}, {
    parentSpanId: spanId,
    traceId: traceId,
    sampled: sampled
  })) : new SentryNonRecordingSpan({
    traceId: traceId
  });
  addChildSpanToSpan(parentSpan, childSpan);
  var client = getClient();
  if (client) {
    client.emit('spanStart', childSpan);
    // If it has an endTimestamp, it's already ended
    if (spanArguments.endTimestamp) {
      client.emit('spanEnd', childSpan);
    }
  }
  return childSpan;
}
function getParentSpan(scope) {
  var span = _getSpanForScope(scope);
  if (!span) {
    return undefined;
  }
  var client = getClient();
  var options = client ? client.getOptions() : {};
  if (options.parentSpanIsAlwaysRootSpan) {
    return getRootSpan(span);
  }
  return span;
}
function getActiveSpanWrapper(parentSpan) {
  return parentSpan !== undefined ? function (callback) {
    return withActiveSpan(parentSpan, callback);
  } : function (callback) {
    return callback();
  };
}
export { continueTrace, startInactiveSpan, startNewTrace, startSpan, startSpanManual, suppressTracing, withActiveSpan };